import { render, staticRenderFns } from "./PersonelIOView.vue?vue&type=template&id=701ee93a&"
import script from "./PersonelIOView.vue?vue&type=script&lang=js&"
export * from "./PersonelIOView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports